<template>
    <div class="c-tabs">
        <ul class="c-tabs__buttons">
            <li class="c-tabs__item">
                <a href="#"
                    class="c-tabs__title"
                    :class="{ 'is-active': selected == tab.name }"
                    v-for="tab in tabs"
                    @click.prevent="select(tab)">{{tab.label}}</a>
            </li>
        </ul>
        <div class="c-tabs__content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tabs: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            selected: null
        }
    },
    methods: {
        select(tab) {
            this.selected = tab.name;
            this.$emit('select', tab.name)
        }
    },
    created() {
        this.select(this.tabs[0]);
    }
}
</script>
